/* global instantsearch algoliasearch */

sendToShowbox = function(event, id, magnet, imdb){
  event.preventDefault();
  // var newUri = `https://btdb.eu/stream.php?${magnet.split('&')[0].replace('magnet:?xt=urn:btih:','infohash=')}&name=${title}&user=1`;
  
  
  var parent = document.getElementById('hit-'+ id);
  var el = document.getElementById('showbox-' + id)  
  if (el){
    parent.removeChild(el);
  }else{
    el = document.createElement('div');
    el.setAttribute("id", 'showbox-' + id) ;
    el.className = "webtor";
    parent.appendChild(el);
  }

  window.webtor = window.webtor || [];
  window.webtor.push({
    id: 'showbox-'+id,
    magnet: magnet,
    imdbId: imdb,
    width: '99%',
    on: function(e) {
        if (e.name == window.webtor.TORRENT_FETCHED) {
            console.log('Torrent fetched!');
        }
        if (e.name == window.webtor.TORRENT_ERROR) {
            console.log('Torrent error!');
        }
    },
  });

};


const search = instantsearch({
  indexName: 'stream',
  searchClient: algoliasearch('7OOB1B3OF6', '4c16fab3a20a692c2e63f48830b554e4'),
});


search.addWidget(
  instantsearch.widgets.hits({
    container: '#hits',
    templates: {
      item(hit){
        let imdb = '';
        if(hit && hit.episode_info && hit.episode_info.imdb){
          imdb = hit.episode_info.imdb;
        }

        let t = `
          <div id="hit-${hit.infohash}">
            <div class="hit-name">
               ${hit.title}
               <div class="hit-links">
                 <a href="${hit.download}" title="Magnet">
                   <img alt="${hit.title}" src="data:image/x-icon;base64,R0lGODlhDgARANU7AMdGFdldKMpHKL4qBONdNaqrqcU3FPd1OLxcSOLn5ra2tbKvsbJ4aduTcsmJe9KWjK0iGM6hnO1zO8vLzOna1s/PztlNNurn6aeopqlZT+jl6KWpqaKhnsx+Zdg9GJseIMwzDJYUDLeBfdFTGa+trqihpKYpILUhCMmalLIwGdPR0shSJMSUj96Pct7PzrGxr/RvOrEdE6VIPb2UkK9YS8/S0aZLQMDGxbVmUtpYM+VmNP///wAAAAAAAAAAAAAAACH5BAEAADsALAAAAAAOABEAAAaYwJ1wSCwaj8gkRZSR2TIiVxFlOg2ug5OJNYxAQAaDQBAGQVA7SsoDWOXGuRXAk6I4ACOLJfT5hCw5IwAMOAEBBDEPQl4Ehgg4Ojo5NEQ4OZGPMBI6DkQPBBISjwcHnJ4EpAgMLQ0dM0QRHQ0NDBwVFQolRCQvFSocGwkJE7pDJDfCGwsXGioLRAoTGhcLCgUFGBNENRjXCkEAOw==" />
                 </a>
                 <a href="#" title="Try to stream (WebTorrent)" onclick="sendToShowbox(event, '${hit.infohash}','${hit.download}', '${imdb}');">
                   <img style="width: 15px;" alt="For streamable content..." src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALDwAACw8BkvkDpQAAABp0RVh0U29mdHdhcmUAUGFpbnQuTkVUIHYzLjUuMTFH80I3AAACf0lEQVRIS2MYPiA4OBiEJQMCAkz9/f2pjkNDQ00ZJCUlGYWEhEr5+Pi+0QKLiop+Y+Dl5WVkZWWtZGRk/M/Nzf2WiYnpJJB9glLMxsZ2GWjuXw4Ojv9wS5iZmf+rqalVJiQkMEJDkiJQXFxsKiEh8W3UEqIAiiU8PDy0t0RMTIwRaFE+kPNdU1OzIjExkfqWADMMm66uroSenl6oi4uLXUZGBlQZZQDFEnFx8XXADNOgr6/vBsz1grW1tdT3CTDT/APGxz92dnZQ7jwMtCwxJSWFA6qWbIBiiY6OTqqKispcYWHh56DIBwr+UFZWnmJoaMgHVU8WQLHEycnJB1iIKWdmZgoaGBiUAcubx9CUdhoYfHLkxhGKJcCU9QOYwu4AU1azu7u7jLm5uS3QV8+Ayfov0EcLUlNTyfIRiiUCAgIXgAZ+BuI/QMv2a2lpaQCD0BUYRw+4uLh+Ojg4ZDY1NTFB9RINSkpKTIElPMQSOzs7YQ0NDX9BQcEzwGD6C4z8M/b29gIyMjJFLCwsv+Tk5M7HxsZKRUZGepiamrYZGRkRhS0tLefz8/P/BlsCNGweMH9oA+NDS0RE5DooPuTl5cuBFosDi5xrwOL/B1CDDxDHAH32C5QSicXAIh+UkP4zgBjAIHvq7OxsZWZmFgA06AvQ4BvAzCkLzEPtIMXGxsazgT5RALpwFjBBLFVVVcWJQfIwrK6uvhRozlIGUM0FjIuvFhYWs5OSkmSAkmekpaVf29jYOAMNDwda9Anoix0zZsxgKC0tZcrKyiIKZ2dng3FBQQETQ3p6uikI5+bmqjQ3NzPn5+erAZOzCdBAwZycHB5gEjYByilD43NEAwYGACTmRI3oRUpVAAAAAElFTkSuQmCC" />
                 </a>
                 <span class="imdbRatingPlugin" data-user="" data-title="${imdb}" data-style="p3"><a href="https://www.imdb.com/title/${imdb}/?ref_=plg_rt_1" target="_blank"><img src="https://ia.media-imdb.com/images/G/01/imdb/plugins/rating/images/imdb_37x18.png" alt="${hit.title} on IMDb" /></a></span>            
               </div>
            </div>
            <div class="hit-description">
               ${hit.pubdate} | ${hit.category} | S:${hit.seeders} | L:${hit.leechers} | s:${hit.size}GB
            </div>
          </div>
          `;
          return t;
          // <iframe id="showbox-${hit.infohash}" name="showbox-${hit.infohash}" width="100%" height="0px" vspace="0" hspace="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen="true" allowtransparency="true" src="" scrolling="auto" frameborder="0"></iframe>
        }
      },
    })
    );


search.addWidget(
  instantsearch.widgets.searchBox({
    container: '#searchbox',
  })
);

search.addWidget(
  instantsearch.widgets.stats({
    container: '#stats',
    templates: {
      body(hit) {
        return `<span role="img" aria-label="emoji">⚡️</span> <strong>${hit.nbHits}</strong> results found ${
          hit.query != "" ? `for <strong>"${hit.query}"</strong>` : ``
        } in <strong>${hit.processingTimeMS}ms</strong>`;
      }
    }
  })
);

search.addWidget(
  instantsearch.widgets.clearRefinements({
    container: '#clear-refinements',
  })
);

search.addWidget(
  instantsearch.widgets.refinementList({
    container: '#cat-list',
    attribute: 'category',
    showMore: true,
  })
);

search.addWidget(
  instantsearch.widgets.refinementList({
    container: '#pubdate-list',
    attribute: 'pubdate',
    showMore: true,
  })
);

search.addWidget(
  instantsearch.widgets.rangeSlider({
    container: "#seeders",
    attribute: "seeders",

  })
);
search.addWidget(
  instantsearch.widgets.rangeSlider({
    container: "#size",
    attribute: "size",

  })
);



search.addWidget(
  instantsearch.widgets.pagination({
    container: '#pagination',
  })
);

search.start();
